export const FETCH_STATUS_LOADING = 'loading';
export const FETCH_STATUS_SUCCESS = 'succeeded';
export const FETCH_STATUS_FAILED = 'failed';
